"use client";

import { useEffect } from 'react';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, normalizeLocale } from '@/lib/siteI18n';
import { capturePromoteKitAttribution } from './promotekitAttribution';

function readCookie(name) {
  return document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`))
    ?.split('=')[1];
}

export default function LocaleAutoRedirect() {
  useEffect(() => {
    if (window.location.pathname !== '/') return;

    let stored = null;
    try {
      stored = window.localStorage.getItem('it_locale');
    } catch (_) {}
    stored = stored || readCookie('it_locale');
    if (stored) return;

    const browserLocale = normalizeLocale(navigator.languages?.[0] || navigator.language);
    if (browserLocale !== DEFAULT_LOCALE && SUPPORTED_LOCALES.includes(browserLocale)) {
      capturePromoteKitAttribution();
      window.location.replace(`/${browserLocale}${window.location.search}${window.location.hash}`);
    }
  }, []);

  return null;
}
